import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

interface Props {
  className?: string
  variant: 'match' | 'invite'
  value: number
  max: number
}

const styles = (theme: Theme) => createStyles({
  root: {
    height: 5,
    backgroundColor: theme.palette.grey[50],
  },
  progress: {
    height: '100%',
    transition: 'width 0.3s ease-in-out',
  },
  match: {
    background: 'linear-gradient(to bottom, #07F7A9, #00E89C)',
  },
  invite: {
    background: 'linear-gradient(to bottom, #5AD8FB, #3CA2FF)',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardProgressBar: React.SFC<InjectedProps> = ({
  className,
  classes,
  variant,
  value,
  max,
}) => {
  const progress = Math.max(0, Math.min(100, Math.round(100 * value / max)))

  return (
    <div className={classNames(className, classes.root)}>
      <div className={classNames(classes.progress, classes[variant])} style={{ width: `${progress}%` }} />
    </div>
  )
}

export default withStyles(styles)(GameCardProgressBar)
